import React from 'react'
import './contactField.css'

export default function ContactField() {

    const [message, setMessage] = React.useState({
        fullname: "",
        email: "",
        subject: "",
        website: "",
        myMessage: ""
    })

    function handleChange(event) {
      const {name, value} = event.target
      setMessage(prevState => ({
        ...prevState,
        [name]: value
      }))

    }

    const styles = {
      color: 'red',
    }
  return (
    <div className='contact-field-container'>
       <h5 className='contact-header'>Contact with us</h5>
       <div className='contact-field-cover'>
       <div className='contact-divider'>
          <img src='/images/recipe.jpg' className='recipe-pic' alt='recipes' />
       </div>
       <div className='contact-field'>
        <form action='/action_page.php'>
       <input
        type='text'
        placeholder= 'Name'
        className='form-input'
        name='fullname'
        value={message.fullname}
        onChange={handleChange}
      />

       <input
        type='text'
        placeholder='Email'
        className='form-input'
        name='email'
        value={message.email}
        onChange={handleChange}
      />

       <input
        type='text'
        placeholder='Subject'
        className='form-input'
        name='subject'
        value={message.subject}
        onChange={handleChange}
      />

      <input
        type='text'
        placeholder='Website'
        className='form-input'
        name='website'
        value={message.website}
        onChange={handleChange}
      />

      <textarea
        rows= '10'
        placeholder='Messages'
        className='form-input'
        name='myMessage'
        value={message.myMessage}
        onChange={handleChange}
      ></textarea>

      <input
       type='submit' 
       className='form-button' 
       value='SEND A MESSAGE'
       />
       </form>
      </div>
      </div>
    </div>
  )
}
